import React from 'react'
import { IconSizeType } from './PersonalTouch'

export const ContactGroup: React.FC<IconSizeType> = ({
  width = 104,
  height = 104,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_425_16890)">
        <rect
          x={32}
          y={32}
          width={40}
          height={40}
          rx={4}
          fill="white"
          shapeRendering="crispEdges"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M61.4022 52.6855C62.3665 53.4388 62.9842 54.5235 63.0972 55.661V55.6761C63.1499 56.226 63.1424 56.7834 63.1348 57.3258V57.4614C63.1273 58.0113 62.6979 58.4859 62.1254 58.5687C62.0124 58.5913 61.8994 58.5913 61.7864 58.5913H58.1781C58.1254 59.4501 57.5454 60 56.664 60H55.5265H54.6753H47.4361C46.5548 60 46.0576 59.646 45.8467 58.855H44.8222C43.9785 58.8475 43.1348 58.8475 42.2911 58.8625C41.568 58.8701 41.0934 58.5763 40.8674 57.951L40.8599 57.8531V56.0075L40.9051 55.7891C40.9176 55.7363 40.9293 55.6836 40.9411 55.6309C40.9645 55.5254 40.9879 55.42 41.0181 55.3145C41.3947 53.9661 42.3514 52.8814 43.6471 52.3314C44.9427 51.7891 46.3966 51.8569 47.6245 52.5273L47.6772 52.5574C48.6414 51.6234 49.8467 51.0734 51.0896 50.8927C50.4418 50.742 49.8467 50.4256 49.3721 49.9435C48.7167 49.2806 48.3627 48.3992 48.3627 47.4652C48.3778 45.5518 49.9521 44 51.8806 44C53.8166 44 55.3909 45.5744 55.3909 47.4953C55.3909 48.4218 55.0294 49.2957 54.3665 49.951C53.9069 50.4105 53.342 50.7119 52.7318 50.8625C53.9597 51.0056 55.1574 51.5104 56.1367 52.3842C56.7017 52.0452 57.3344 51.8267 58.0275 51.7288C58.0727 51.7137 58.1179 51.7137 58.1631 51.7137C56.8071 51.5179 55.7601 50.3653 55.7601 48.9718C55.7601 48.2411 56.0463 47.548 56.5736 47.0207C57.1085 46.4859 57.8166 46.1921 58.5623 46.1921C60.1066 46.1921 61.3646 47.4426 61.3646 48.9718C61.3646 49.71 61.0708 50.4105 60.5435 50.9379C60.1216 51.3597 59.5868 51.6234 59.0143 51.7137C59.858 51.7966 60.6941 52.1281 61.4022 52.6855ZM61.8768 57.3107V56.9115C61.8844 56.6403 61.8843 56.3616 61.8693 56.0829C61.809 54.9228 61.1537 53.9058 60.1216 53.3559C59.1348 52.8286 57.9747 52.8286 57.003 53.3559C57.8392 54.5009 58.2309 55.7966 58.1857 57.3107H61.8768ZM56.9201 58.4859V58.1318L56.9126 58.1394V57.838V57.71L56.9127 57.7046C56.9202 57.0061 56.9272 56.3524 56.7469 55.7062C56.3778 54.403 55.5265 53.3258 54.3363 52.6855C53.6132 52.2863 52.8147 52.0904 52.0086 52.0904C51.4964 52.0904 50.9842 52.1657 50.4795 52.3314C48.5435 52.9492 47.2177 54.6516 47.0972 56.6629C47.067 57.145 47.0746 57.6497 47.0821 58.1318V58.5085C47.0896 58.6516 47.1047 58.7119 47.3156 58.7119H52.0011H56.6866C56.8825 58.7119 56.9201 58.6742 56.9201 58.4859ZM45.8165 57.5669C45.7412 56 46.0877 54.6817 46.8636 53.5443C45.9898 53.1224 44.9729 53.1149 44.0538 53.5292C43.1122 53.9586 42.4493 54.7646 42.2309 55.7363C42.1405 56.1356 42.1329 56.5499 42.1329 56.9944C42.1329 57.081 42.131 57.1695 42.1292 57.258C42.1273 57.3465 42.1254 57.435 42.1254 57.5217V57.5669H42.1857H45.8165ZM58.5623 47.4652C57.7186 47.4727 57.0331 48.1507 57.0331 48.9793H57.0256C57.0256 49.8079 57.7186 50.4859 58.5623 50.4859C58.9842 50.4859 59.3683 50.3202 59.6621 50.0264C59.9484 49.7401 60.099 49.3635 60.099 48.9718C60.0915 48.1431 59.406 47.4652 58.5623 47.4652ZM49.6207 47.4878C49.6207 48.0753 49.8542 48.6252 50.2761 49.0471H50.261C50.6904 49.4765 51.2629 49.7175 51.8655 49.7175C53.1085 49.7175 54.1254 48.7156 54.1254 47.4953C54.1329 46.9077 53.8919 46.3503 53.47 45.9284C53.0482 45.5066 52.4832 45.2731 51.8806 45.2731C50.6376 45.2731 49.6207 46.2674 49.6207 47.4878ZM48.2349 49.1604C48.2349 50.6895 46.9769 51.9325 45.4326 51.9325C43.8884 51.925 42.6379 50.6745 42.6379 49.1453C42.6379 47.6161 43.8959 46.3732 45.4402 46.3732C46.1859 46.3732 46.8865 46.6669 47.4213 47.2018C47.9486 47.7366 48.2349 48.4297 48.2349 49.1604ZM45.4402 47.6387C44.5965 47.6387 43.9034 48.3167 43.9034 49.1453L43.8959 49.1378C43.8959 49.5295 44.0466 49.9061 44.3328 50.1924C44.6266 50.4862 45.0183 50.6519 45.4326 50.6519C45.8545 50.6745 46.2387 50.5012 46.5249 50.215C46.8112 49.9362 46.9693 49.5596 46.9693 49.1528C46.9693 48.3167 46.2838 47.6387 45.4402 47.6387Z"
          fill="#FCD34D"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_425_16890"
          x={0}
          y={0}
          width={104}
          height={104}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={16} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_425_16890"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_425_16890"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
